import React, { useState } from "react";
import styles from "./NewPostSocialFeed.module.scss";
import AutoGrowingTextarea from "../UI/AutoGrowingTextArea/AutoGrowingTextArea";
import ImageSVG from "../SVGComponents/ImageSVG";
import VideoSVG from "../SVGComponents/VideoSVG";
import SendSVG from "../SVGComponents/SendSVG";
import { RxCross2 } from "react-icons/rx";
import Modal from "../Modal/Modal";
import { API } from "../../service/Interceptor";
import { combineClasses, serverFiles, compressImage } from "../../utils/utils";
import toast from "../Toast/toast";
import { useDispatch } from "react-redux";
import { createPost, getAllPosts } from "../../reducer/postsSlice";
import SpinnerLoader from "../UI/SpinnerLoader/SpinnerLoader";
// import Tooltip from "components/common/Tooltip/Tooltip";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import { useDisclosure } from "hooks";
// import { newPostTags } from "../../utils/utils";
import NewPostSocialFeedForModal from "./NewPostSocialFeedForModal";
const tagsOptions = [
  // {
  //   label: "All",
  //   value: "ALL",
  // },
  {
    label: "Advice",
    value: "ADVICE",
  },
  {
    label: "Network",
    value: "NETWORK",
  },
  {
    label: "Thoughts",
    value: "THOUGHTS",
  },
];

const NewPostSocialFeed = ({ containerClassName }) => {
  const [description, setDescription] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [newPostModal, setNewPostModal] = useState(false);
  const {
    isOpen: tagsModal,
    close: closeTagsModal,
    toggle: togglTagsModale,
  } = useDisclosure();

  const [mediaIds, setMediaIds] = useState([]);
  const dispatch = useDispatch();

  const unixTimestamp = Math.floor(Date.now() / 1000);

  const handleMediaUpload = async (e, type) => {
    const files = Array.from(e.target.files || []);

    const isAcceptedType = (file) =>
      type === "image"
        ? file.type.startsWith("image/")
        : file.type.startsWith("video/");

    const rejectedFiles = files.filter((file) => !isAcceptedType(file));

    if (rejectedFiles?.length > 0) {
      toast.error(`Only ${type} files are allowed. Some files were rejected.`);
      return;
    }

    const MAX_VIDEO_SIZE = 20 * 1024 * 1024; // 20MB

    for (let file of files) {
      let fileToUpload = file;
      if (type === "image") {
        fileToUpload = await compressImage(file);
      }

      const previewUrl = URL.createObjectURL(fileToUpload);
      const tempId = Math.random().toString(36).substr(2, 9);

      const formData = new FormData();
      formData.append("fileName", fileToUpload);

      if (type === "image") {
        // Add loading preview
        setImages((prev) => [
          ...prev,
          { id: tempId, previewUrl, uploading: true },
        ]);

        try {
          const res = await API.post("api/media", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          const uploadedFile = res.data[0];

          setImages((prev) =>
            prev.map((img) =>
              img.id === tempId
                ? {
                  id: uploadedFile.id,
                  path: uploadedFile.path,
                  previewUrl: null,
                  uploading: false,
                }
                : img
            )
          );
          setMediaIds((prev) => [...prev, uploadedFile.id]);
        } catch (err) {
          console.error("Image upload failed:", err);
        }
      }

      if (type === "video") {
        if (file.size > MAX_VIDEO_SIZE) {
          toast.error(`"${file.name}" exceeds 20MB limit and was skipped.`);
          continue;
        }

        // Add loading preview
        setVideos((prev) => [
          ...prev,
          { id: tempId, previewUrl, uploading: true },
        ]);

        try {
          const res = await API.post("api/media", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          const uploadedFile = res.data[0];

          setVideos((prev) =>
            prev.map((vid) =>
              vid.id === tempId
                ? {
                  id: uploadedFile.id,
                  path: uploadedFile.path,
                  previewUrl: null,
                  uploading: false,
                }
                : vid
            )
          );
          setMediaIds((prev) => [...prev, uploadedFile.id]);
        } catch (err) {
          console.error("Video upload failed:", err);
        }
      }
    }
  };

  const validateDescription = (val) => {
    if (!val.trim()) return "Description cannot be empty.";
    if (val.length < 10) return "Minimum 10 characters required.";
    if (val.length > 500) return "Maximum 500 characters allowed.";
    return "";
  };

  const handlePost = async () => {
    if (!selectedTag) {
      toast.error("Please select a tag and enter a description");
      return;
    }

    if (
      description === "" &&
      selectedTag === "" &&
      images.length === 0 &&
      videos.length === 0
    ) {
      toast.error("Cannot Create Post");
      return;
    }

    const descriptionError = validateDescription(description);
    if (descriptionError) {
      toast.error(descriptionError);
      return;
    }

    const payload = {
      tags: [selectedTag],
      content: description,
      mediaIds: mediaIds,
    };

    try {
      const res = await dispatch(createPost(payload));
      // console.log(res);

      if (res?.payload) {
        toast.success("Post Uploaded Successfully");
        setDescription("");
        setSelectedTag("");
        setImages([]);
        setVideos([]);
        setMediaIds([]);
        dispatch(getAllPosts({ pageNo: 1, perPage: 5, sortBy: "LATEST" }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => {
      const removedImage = prevImages[index];
      setMediaIds((prevIds) => prevIds.filter((id) => id !== removedImage.id));
      return prevImages.filter((_, i) => i !== index);
    });
  };

  const handleRemoveVideo = (index) => {
    setVideos((prevVideos) => {
      const removedVideo = prevVideos[index];
      setMediaIds((prevIds) => prevIds.filter((id) => id !== removedVideo.id));
      return prevVideos.filter((_, i) => i !== index);
    });
  };

  return (
    <>
      {newPostModal && (
        <Modal
          background="white"
          modalOpen={newPostModal}
          onClose={() => setNewPostModal(false)}
        >
          <NewPostSocialFeedForModal onClose={() => setNewPostModal(false)} />
        </Modal>
      )}
      <section
        className={combineClasses(styles.newPostSocialFeed, containerClassName)}
        onClick={() => setNewPostModal(true)}
      >
        <div className={styles.topHeading}>
          <p>New Post</p>
        </div>
        <div className={styles.newPostSeperator} />

        {/* <div className={styles.newPostSeperator} />

        <p className={styles.subHeading}>What is this post about?</p>
        <div className={styles.tagsDiv}>
          {newPostTags.map((item) => (
            <div className={styles.tags} key={item.value}>
              <span>{item.label}</span>
            </div>
          ))}
        </div> */}

        {selectedTag !== "" && (
          <div
            onClick={() => setSelectedTag("")}
            className={styles.selected_tag}
          >
            <p>{selectedTag}</p>
            <CrossIconSVG color="white" height="16" width="16" />
          </div>
        )}

        <div className={styles.newPostInput}>
          {/* <AutoGrowingTextarea
            //label="Your Post"
            value={description}
            placeholder="Write here..."
            onChange={(e) => setDescription(e.target.value)}
            className={styles.newPost_textarea}
            labelClassName={styles.newPostLabel}
            onFocus={() => setNewPostModal(true)}
            rows={1}
          /> */}
          <div style={{ width: "100%", padding: "0.5rem" }}></div>

          {/* <div className={styles.imgMainDiv} >
             <label className={styles.imgLabel}>Add your images</label>
             <div className={styles.imgContainer}>
          <div className={styles.preview_Media}>
            {images?.map((img, idx) => (
              <div key={`imgL{idx}`} className={styles.preview_imageWrapper}>
                <img
                  src={img.previewUrl || serverFiles(img.path)}
                  alt={`upload-img-${idx}`}
                  style={{ opacity: img.uploading ? 0.5 : 1 }}
                />
                {img.uploading && (
                  <div className={styles.loadingOverlay}>
                    <SpinnerLoader />
                  </div>
                )}
                {!img.uploading && (
                  <button
                    className={styles.preview_removeBtn}
                    onClick={() => handleRemoveImage(idx)}
                  >
                    <RxCross2 color="#6570FC" />
                  </button>
                )}
               </div> 
            ))}

            {videos?.map((vid, idx) => (
              <div key={`vid-${idx}`} className={styles.preview_imageWrapper}>
                <video
                  src={vid.previewUrl || serverFiles(vid.path)}
                  controls
                  width="350"
                  height="350"
                  style={{ opacity: vid.uploading ? 0.5 : 1 }}
                />
                {vid.uploading && (
                  <div className={styles.loadingOverlay}>
                    <SpinnerLoader />
                  </div>
                )}
                {!vid.uploading && (
                  <button
                    className={styles.preview_removeBtn}
                    onClick={() => handleRemoveVideo(idx)}
                  >
                    <RxCross2 color="#6570FC" />
                  </button>
                )}
              </div>
            ))}
          </div>
              </div>
            </div> */}
          {images?.map((img, idx) => (
            <div key={`imgL{idx}`} className={styles.preview_imageWrapper}>
              <img
                src={img.previewUrl || serverFiles(img.path)}
                alt={`upload-img-${idx}`}
                style={{ opacity: img.uploading ? 0.5 : 1 }}
              />
              {img.uploading && (
                <div className={styles.loadingOverlay}>
                  <SpinnerLoader />
                </div>
              )}
              {!img.uploading && (
                <button
                  className={styles.preview_removeBtn}
                  onClick={() => handleRemoveImage(idx)}
                >
                  <RxCross2 color="#6570FC" />
                </button>
              )}
            </div>
          ))}
          {videos?.map((vid, idx) => (
            <div key={`vid-${idx}`} className={styles.preview_imageWrapper}>
              <video
                src={vid.previewUrl || serverFiles(vid.path)}
                controls
                width="350"
                height="350"
                style={{ opacity: vid.uploading ? 0.5 : 1 }}
              />
              {vid.uploading && (
                <div className={styles.loadingOverlay}>
                  <SpinnerLoader />
                </div>
              )}
              {!vid.uploading && (
                <button
                  className={styles.preview_removeBtn}
                  onClick={() => handleRemoveVideo(idx)}
                >
                  <RxCross2 color="#6570FC" />
                </button>
              )}
            </div>
          ))}
          <div
            className={styles.newPost_bottom}
            onClick={() => setNewPostModal(true)}
          >
            <p className={styles.newPost_shareCreatives}>
              {/* Share your Creatives */}
            </p>

            <div className={styles.newPost_bottom_right}>
              <div className={styles.icon_button_wrapper}>
                <label htmlFor={`image-upload-${unixTimestamp}`}>
                  <ImageSVG color="#7E7E7E" />
                  {/* <Tooltip force={true} data={"Post Image"}>
                  </Tooltip> */}
                </label>
                <input
                  id={`image-upload-${unixTimestamp}`}
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => {
                    handleMediaUpload(e, "image");
                  }}
                  disabled={true}
                />

                <label htmlFor={`video-upload-${unixTimestamp}`}>
                  <VideoSVG color="#7E7E7E" />
                  {/* <Tooltip force={true} data={"Post Video"}>
                  </Tooltip> */}
                </label>
                <input
                  id={`video-upload-${unixTimestamp}`}
                  type="file"
                  accept="video/*"
                  multiple
                  onChange={(e) => handleMediaUpload(e, "video")}
                  disabled={true}
                />
              </div>

              <button
                className={styles.addTag}
                onClick={togglTagsModale}
                disabled={true}
              >
                Add Tag
                {/* <Tooltip data={"Add Tag"} force={true}>
                </Tooltip> */}
              </button>

              {tagsModal && (
                <Modal
                  height="fit-content !important"
                  width="25rem"
                  background="white"
                  modalOpen={tagsModal}
                  onClose={closeTagsModal}
                  drawer={{
                    isDrawer: true,
                  }}
                >
                  <div className={styles.tagsSection}>
                    <div className={styles.addTags_top}>
                      <label className={styles.addTags_heading}>Add Tags</label>
                      <RxCross2 size={20} onClick={closeTagsModal} />
                    </div>

                    <div className={styles.addTags_seperator}></div>

                    <div className={styles.tagsGrid}>
                      {tagsOptions?.map((option, index) => (
                        <button
                          key={index}
                          className={`${styles.tagButton} ${selectedTag === option.value ? styles.selected : ""
                            }`}
                          onClick={() => {
                            closeTagsModal();
                            setSelectedTag(option.value);
                          }}
                        >
                          {option.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </Modal>
              )}

              <button
                onClick={handlePost}
                className={styles.postButton}
                disabled={true}
              >
                <SendSVG />
                {/* <Tooltip force={true} data={"Send Post"} place="bottom">
                </Tooltip> */}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewPostSocialFeed;
